module.exports = __webpack_public_path__ + "static/media/Virtualization.ccd84b2c.png";